import { render } from "./CoursesSlide.vue?vue&type=template&id=3006d366&scoped=true"
import script from "./CoursesSlide.vue?vue&type=script&lang=js"
export * from "./CoursesSlide.vue?vue&type=script&lang=js"

import "./CoursesSlide.vue?vue&type=style&index=0&id=3006d366&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3006d366"]])

export default __exports__